import React from "react";

const DropDownIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3337 8.33301L10.0003 11.6663L6.66699 8.33301"
          stroke="#04080B"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      
    </>
  );
};
export default DropDownIcon;
